import { v4 } from "uuid";
import {
  fromAbridgedCondition,
  gambitActions,
  generateDefaultGambit,
  generateGambit
} from "./gambitFactory";
import { IAbridgedGambit, IEntity, IStats, IWaveActor } from "./types";

export const generateStats = (): IStats => ({
  hp: { value: 8, max: 10 },
  mp: { value: 5, max: 5 },
  attack: { value: 2, max: 2 },
  defense: { value: 1, max: 1 },
  mpAttack: { value: 3, max: 3 },
  mpDefense: { value: 2, max: 2 },
  vitality: { value: 1, max: 1 }
});

export const generateAffinities = () => ({
  ice: 1,
  fire: 1,
  water: 1,
  earth: 1,
  wind: 1,
  electric: 1
});

export const generateBaseEntity = (name: string): IEntity => {
  const stats = generateStats();
  return {
    id: v4(),
    frame: { name },
    affinities: generateAffinities(),
    stats,
    statuses: [],
    gambits: [generateDefaultGambit()],
    lastAction: null
  };
};

interface IAbridgedData {
  name: string;
  gambits: IAbridgedGambit[];
}

export const generateAbridgedEntity = (data: IAbridgedData) => {
  const baseEntity = generateBaseEntity(data.name);
  baseEntity.gambits = data.gambits.map(abridgedGambit => {
    const [targetKey, abridgedCondition, actionKey] = abridgedGambit.bits;

    return generateGambit({
      target: { key: targetKey },
      condition: fromAbridgedCondition(abridgedCondition),
      action: gambitActions[actionKey]
    });
  });

  return baseEntity;
};

export const generateEntity = (data: IWaveActor) => {
  return data.actor;
};
